export const defaultDialerTableColumns = [
    {
        prop: "campaignName",
        align: "center",
        fixed: false,
        label: "campaignName",
        minWidth: 130
    },
    {
        prop: "campaignType",
        align: "center",
        fixed: false,
        label: "campaignType",
        minWidth: 130
    },
    { 
        prop: "campaignID",
        align: "center",
        fixed: false,
        label: "campaignID",
        minWidth: 130
    },
    {
        prop: "TotalCalls",
        align: "center",
        fixed: false,
        label: "TotalCalls",
        minWidth: 130
    },
    {
        prop: "TotalLeg1AnswerCalls",
        align: "center",
        fixed: false,
        label: "TotalLeg1AnswerCalls",
        minWidth: 130
    },
    {
        prop: "TotalLeg1RingingCalls",
        align: "center",
        fixed: false,
        label: "TotalLeg1RingingCalls",
        minWidth: 130
    },
    {
        prop: "TotalLeg2AnswerCalls",
        align: "center",
        fixed: false,
        label: "TotalLeg2AnswerCalls",
        minWidth: 130
    },
    {
        prop: "TotalLeg2RingingCalls",
        align: "center",
        fixed: false,
        label: "TotalLeg2RingingCalls",
        minWidth: 130
    },
    {
        prop: "TotalOriginatingCalls",
        align: "center",
        fixed: false,
        label: "TotalOriginatingCalls",
        minWidth: 130
    },
    {
        prop: "TotalPendingCalls",
        align: "center",
        fixed: false,
        label: "TotalPendingCalls",
        minWidth: 130
    },
    { 
        prop: "TypeName",
        align: "center",
        fixed: false,
        label: "TypeName",
        minWidth: 130
    },
    { 
        prop: "Queue",
        align: "center",
        fixed: false,
        label: "Queue",
        minWidth: 130
    },
    { 
        prop: "CurrentAwaitingCallers",
        align: "center",
        fixed: false,
        label: "CurrentAwaitingCallers",
        minWidth: 250
    },
    { 
        prop: "CurrentTotalAgents",
        align: "center",
        fixed: false,
        label: "CurrentTotalAgents",
        minWidth: 250
    },
    { 
        prop: "CurrentFreeAgents",
        align: "center",
        fixed: false,
        label: "CurrentFreeAgents",
        minWidth: 250
    }
]